<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(category)="data">
                  {{ data.item.category.name }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.name,data.item.quantity )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal id="edit-product" centered title="Reconcile Product Quantity" title-class="font-14" hide-footer>
          <form @submit.prevent="editProduct">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label>Product Name</label>
              <input v-model="name" type="text" readonly class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Current Quantity</label>
              <input v-model="quantity" type="text" readonly class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Actual Quantity</label>
              <input v-model="newquantity" type="text" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-product')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { productMethods, productComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Reconcile Stock",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        title: "Reconcile Stock",
        items: [ {text: "Dashboard",to: "/",}, {text: "Reconcile Stock",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'category', label: 'Category', visible: true },
            { key: 'quantity', label: 'Quantity', visible: true },
            { key: 'addedby', label: 'Added by', visible: true },
            { key: 'actions', label: 'Reconcile', visible: true },
          ],
        id:'',
        name:'',
        category:'',
        unit:'',
        quantity:'0',
        price:'',
        newquantity:'0',
      };
    },
    computed: {
      ...productComputed,
      List() { return this.products.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.products.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.products.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchProducts();
      this.TotalRows = this.products.length;
      this.isBusy=false;
    },
    methods: {
      ...productMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,name,quantity){
        this.id=id;
        this.name=name;
        this.quantity=quantity;
        this.$bvModal.show('edit-product')
      },
      async editProduct(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("newquantity", this.newquantity);
      let url = "/reconcilestock";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchProducts();
          this.$bvModal.hide('edit-product');
          this.name="";
          this.newquantity="";
        }
      });
      },
    },
  };
  </script>